import { render, staticRenderFns } from "./InsureItem.vue?vue&type=template&id=aacb9366&"
import script from "./InsureItem.vue?vue&type=script&lang=js&"
export * from "./InsureItem.vue?vue&type=script&lang=js&"
import style0 from "./InsureItem.vue?vue&type=style&index=0&id=aacb9366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports